// removed by extract-text-webpack-plugin
module.exports = {"InfoListItem":"l-VG0AQaRT6r8ni6-i5bn","date":"_11q2KaJqLkx_A5dru5Beq5","eventTime":"_2udEpH9UVyrcNUGJ95YXRz","title":"_1nDFwEgQv6kebTIcfwFoZq","subtitle":"btXgqgj1celgKYSaH7r_h"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InfoList/InfoListItem/InfoListItem.css
// module id = 496
// module chunks = 8